import { Controller } from "@hotwired/stimulus";

/*
 * Use this controller to:
 * 1. Fetch state from the store.
 * 2. Build a url string with that data, and dispatch an event with it.
 *
 *    This will most probably be a reload event that requires some 
 *    client side data.
 */

export default class extends Controller {
  static values = {
    dispatchName: String,
    eventName: String,
    storeKey: String
  };

  requestState() {
    this.dispatch("requestState", {
      detail: { id: this.storeKeyValue, requesterId: this._id },
      prefix: false,
    });
  }

  dispatchWithState({ detail: { requesterId, values } }) {
    if (requesterId === this._id) {
      const f = new FormData();

      // TODO: Needs expanding to support data types other than arrays
      f.append(this.dispatchNameValue, values.join(","));

      const params = new URLSearchParams(f);

      this.dispatch(this.eventNameValue, {
        detail: { queryString: params.toString() },
        prefix: false,
        target: document
      });
    }
  }

  get _id() {
    return `${this.identifier}-${this.element.id}`;
  }
}
